import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import Image from "gatsby-image"
import { brandViolet, brandPink } from "../styles/colors"

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  max-width: 1024px;
  margin: auto;
`

const LinksContainer = styled.div`
  display: flex;
`

const Logo = styled.div`
  box-shadow: none;
`

const StyledLink = styled(Link)`
  padding: 0 10px;
  box-shadow: none;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  text-decoration: none;
  color: ${props => {
    console.log(props)
    return brandViolet
  }};

  &:hover {
    color: ${brandPink};
  }

  &[data-active] {
    color: ${brandPink};
`

const isActive = ({ isCurrent }) => {
  return isCurrent ? { "data-active": true } : {}
}

const Header = ({ light = false }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(absolutePath: { regex: "/assets/kernelgonnapanic.png/" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <HeaderContainer>
      {!light && (
        <>
          <Logo>
            <Link to="https://kernelgonnapanic.pl">
              <Image fixed={data.logo.childImageSharp.fixed} />
            </Link>
          </Logo>
          <LinksContainer>
            {/* <StyledLink getProps={isActive} to="/omnie">
          O mnie
        </StyledLink> */}
            <StyledLink getProps={isActive} to="/blog">
              Blog
            </StyledLink>
            <StyledLink getProps={isActive} to="/konsultacje">
              Konsultacje
            </StyledLink>
            <StyledLink getProps={isActive} to="/newsletter">
              Newsletter
            </StyledLink>
          </LinksContainer>
        </>
      )}
    </HeaderContainer>
  )
}

export default Header
